import { ROOT_DIR_ID } from 'shared/constants/directory';
import { resolveExportDocumentName } from '../resolveExportDocumentName';

export type ExportDocumentOutDto = {
  isParentRootDirectory: boolean;
  name: string;
  number: string;
  parentId?: string;
};

export type ExportPayloadParams = {
  currentDirectoryId: string;
  fileTitle?: string;
};

export function createExportPayload({
  currentDirectoryId,
  fileTitle,
}: ExportPayloadParams): ExportDocumentOutDto {
  const isRoot = currentDirectoryId === ROOT_DIR_ID;
  const normalizedName = resolveExportDocumentName({
    preferredName: fileTitle,
  });

  return {
    isParentRootDirectory: isRoot,
    name: normalizedName,
    number: '',
    ...(isRoot ? {} : { parentId: currentDirectoryId }),
  };
}
